// ─── COMMISSION CALCULATOR ──────────────────────────────────────────────────
// Front Gross  = amount earned by the Front Desk team (salesperson negotiation)
// Back Gross   = amount earned by Finance / Back End team (F&I products)
// Spiffs       = separate bonus paid directly — NOT part of commission calculation
export const calcSaleCommission = (sale, userData) => {
  if (userData.commissionMode === 'combined') {
    // One % on (front + back) only — spiffs bypass commission and go direct
    return (sale.frontGross + sale.backGross) * (userData.bothPct / 100);
  } else {
    // Split: frontPct on front-desk gross, backPct on finance/back-end gross
    return sale.frontGross * (userData.frontPct / 100) +
           sale.backGross  * (userData.backPct  / 100);
  }
};

// ─── DYNAMIC THEME ENGINE ────────────────────────────────────────────────────
export const getTimeOfDayTheme = () => {
  const hour = new Date().getHours();
  
  if (hour >= 5 && hour < 12) {
    return {
      name: 'morning',
      bg: '#0a0f14',
      primary: '#00ff99',
      secondary: '#00d4ff',
      accent: '#ffd000',
      heroGradient: 'linear-gradient(135deg, #00ff99, #00d4ff)',
      cardBg: 'rgba(0,255,136,.08)',
      greeting: '☀️ Good Morning'
    };
  } else if (hour >= 12 && hour < 18) {
    return {
      name: 'afternoon',
      bg: '#0f0f12',
      primary: '#00c86e',
      secondary: '#00a8d9',
      accent: '#ffc800',
      heroGradient: 'linear-gradient(135deg, #00c86e, #00a8d9)',
      cardBg: 'rgba(0,200,110,.06)',
      greeting: '👋 Good Afternoon'
    };
  } else if (hour >= 18 && hour < 23) {
    return {
      name: 'evening',
      bg: '#0f0f14',
      primary: '#00b87a',
      secondary: '#0098c9',
      accent: '#ffb800',
      heroGradient: 'linear-gradient(135deg, #00b87a, #0098c9)',
      cardBg: 'rgba(0,184,122,.06)',
      greeting: '🌆 Good Evening'
    };
  } else {
    return {
      name: 'night',
      bg: '#0a0a12',
      primary: '#00a888',
      secondary: '#0088b9',
      accent: '#ff9800',
      heroGradient: 'linear-gradient(135deg, #00a888, #0088b9)',
      cardBg: 'rgba(0,168,136,.06)',
      greeting: '🌙 Burning the Midnight Oil'
    };
  }
};

// ─── CAR PROGRESSION ─────────────────────────────────────────────────────────
// NOTE: CAR_IMAGES should be imported separately and passed in when available
export const calcGrowthLevel = (sales, activities, CAR_IMAGES = {}) => {
  const points = sales.length * 10 + activities.length;
  const level = Math.floor(points / 50) + 1;
  const progress = (points % 50) / 50 * 100;
  
  const stages = [
    { image: CAR_IMAGES.civic   || '', name: 'Entry Sedan',      desc: 'Honda Civic Si' },
    { image: CAR_IMAGES.bmw     || '', name: 'Sport Luxury',     desc: 'BMW M4 Competition' },
    { image: CAR_IMAGES.porsche || '', name: 'Sports Coupe',     desc: 'Porsche 911 Turbo', square: true },
    { image: CAR_IMAGES.ferrari || '', name: 'Exotic Supercar',  desc: 'Ferrari 812 Superfast' },
    { image: CAR_IMAGES.bugatti || '', name: 'Ultimate Hypercar', desc: 'Bugatti Veyron', square: true }
  ];
  
  const index = Math.min(level - 1, stages.length - 1);
  const car = stages[index];
  
  return { 
    level, 
    progress, 
    carImage: car.image,
    carSquare: car.square || false,
    carName: car.name, 
    carDesc: car.desc, 
    points 
  };
};

// ─── DEFAULT STATE ───────────────────────────────────────────────────────────
export const defaultUser = {
  name: '',
  dealership: '',
  role: 'Salesperson',
  unitsGoal: 20,
  grossGoal: 8000,
  drawMonthly: 2500,
  commissionMode: 'split',
  frontPct: 8,
  backPct:  15,
  bothPct:  15,
  newUnitBonus:  150,
  usedUnitBonus: 100,
  callsTarget: 12,
  textsTarget: 4,
  emailsTarget: 8,
  useAutoTargets: true,
};

export const defaultBonusTiers = [
  { id: 'T1', unitsSold: 10, bonusAmount: 500  },
  { id: 'T2', unitsSold: 15, bonusAmount: 1000 },
  { id: 'T3', unitsSold: 20, bonusAmount: 1500 },
  { id: 'T4', unitsSold: 25, bonusAmount: 2000 },
  { id: 'T5', unitsSold: 30, bonusAmount: 2500 },
];
